import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {QUERY_KEYS} from '@/queryClient'
import {httpGetSiarExportDetail} from '@/features/projects/siar-bulk-export/http/siarBulkExport.http'
import {SiarExportDetail} from '@/features/projects/siar-bulk-export/types'

export const useGetSiarExportDetail = (id: string, options?: Pick<UseQueryOptions<SiarExportDetail>, 'enabled'>) =>
    useQuery({
        queryKey: [QUERY_KEYS.SIAR_EXPORT_DETAIL, id],
        queryFn: () => httpGetSiarExportDetail({id}),
        ...options
    })
